import { C, ThresholdConfig, getColor, getSeverity } from '../../MapSharedData';
import { PostcodeTooltip } from '../types';

interface Props {
  tooltip: PostcodeTooltip;
  cfg: ThresholdConfig;
}

export function PostcodeTooltipCard({ tooltip, cfg }: Props) {
  const { count, place, region, postcode } = tooltip.marker;
  const hasData = count > 0;
  const sev = getSeverity(count, cfg);
  return (
    <div
      className="fixed rounded-10 px-3.5 py-2.5 text-[13px] pointer-events-none z-[9999] shadow-popup min-w-[180px]"
      style={{ left: tooltip.x + 14, top: tooltip.y - 10, background: C.textPrimary, color: C.bg }}
    >
      <div className="flex items-center gap-2 mb-1">
        <div
          className="w-2.5 h-2.5 rounded-full border-[1.5px] border-white"
          style={{ background: hasData ? getColor(count, cfg) : C.noData }}
        />
        <span className="font-semibold">{postcode}</span>
      </div>
      {(place || region) && (
        <div className="text-xs text-v2blueGray-200 mb-1.5">
          {[place, region].filter(Boolean).join(' · ')}
        </div>
      )}
      {hasData ? (
        <>
          <div style={{ color: sev.color }}>{count.toLocaleString()} incidents</div>
          <div className="text-[11px] mt-0.5" style={{ color: sev.color }}>
            {sev.label}
          </div>
          <div className="text-[11px] text-v2blueGray-500 mt-1.5 italic">Click to focus</div>
        </>
      ) : (
        <div className="text-v2blueGray-300">No incidents</div>
      )}
    </div>
  );
}
